/**
 * Coarse `page_type` for the current route — one of the guide's four shipped
 * values (`home` / `course` / `category` / `checkout`) plus the proposed
 * additions, all slug-shaped so they pass the vocabulary format rule.
 *
 * Shared by `page_view` and by element tracking, so a click on the home page
 * and the `page_view` that preceded it agree on which page they happened on.
 * Note the guide's rule 5: it is `course`, never `course_detail`.
 */
export const resolvePageType = (pathname: string): string => {
  if (pathname === "/") return "home";
  if (/^\/course\/[^/]+\/buy/.test(pathname)) return "checkout";
  if (/^\/course\/[^/]+\/lesson\//.test(pathname)) return "lesson";
  if (/^\/course\//.test(pathname)) return "course";
  if (/^\/categories\//.test(pathname)) return "category";
  if (/^\/search/.test(pathname)) return "search";
  if (/^\/miniapp\//.test(pathname)) return "miniapp";
  if (/^\/educator\//.test(pathname)) return "educator";
  if (/^\/profile\/wishlist/.test(pathname)) return "wishlist";
  if (/^\/profile\/transactions/.test(pathname)) return "transactions";
  if (/^\/profile/.test(pathname)) return "profile";
  if (/^\/my-courses/.test(pathname)) return "my_courses";
  return "other";
};

/** `resolvePageType` for wherever the browser currently is. */
export const currentPageType = (): string =>
  typeof window === "undefined" ? "other" : resolvePageType(window.location.pathname);
